import templateStr from 'text!./templates/binary-choice.html';

let controlId = 0;

export default [() => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            titleLeft: '@',
            titleRight: '@',
            valueLeft: '=',
            valueRight: '=',
            model: '=',
            flavor: '@',
            isDisabled: '&'
        },
        controller: ['$scope', ($scope) => {
            $scope.controlId = `binaryinputctrlx${controlId++}`;
            $scope.name = $scope.controlId;
        }]
    };
}];
